import axios, { AxiosResponse } from 'axios';

export const MODULE_COPY_URL = 'front/module-copy';

type CopyModuleParams = {
  sourceModuleGuid: string;
  /** Periodo desde cuyo "+ Añadir módulo" se abrió el wizard. */
  targetEvaluationPeriodId: string;
  targetProgramGuid: string;
};

/** Solo confirma el módulo creado: no trae nombre, estado ni submódulos (`items` llega vacío). */
type CopyModuleResponse = AxiosResponse<{
  status: string;
  data: { guid: string; parent_guid: string | null; evaluation_period_id: string; items: unknown[] };
}>;

/**
 * POST copia profunda e independiente de un módulo raíz (submódulos, lecciones y
 * bloques Mint) al programa destino. Backend TAN-10196: la copia nace siempre oculta
 * y en borrador, y el periodo se escribe en la distribución del programa.
 */
export function copyModule({ sourceModuleGuid, targetEvaluationPeriodId, targetProgramGuid }: CopyModuleParams): Promise<CopyModuleResponse> {
  return axios.post(MODULE_COPY_URL, {
    source_module_guid: sourceModuleGuid,
    target_evaluation_period_id: targetEvaluationPeriodId,
    target_program_guid: targetProgramGuid,
  });
}
